
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PermitAll } from '@csx/security';
/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import * as _ from 'lodash';
import { SelectItem } from 'primeng/api/selectitem';
import { debounceTime } from 'rxjs/operators';
import { LmsBaseAppComponent } from '../../core/component/base-app/lms-base-app.component';
import { BaseResponse } from '../../core/model/base-response.model';
import { LocoDetail } from '../../core/model/loco-detail.model';
import { LocoTransfer } from '../../core/model/loco-transfer.model';
import { Response } from '../../core/model/response.model';
import { ContextMenuOperationsService } from '../../core/services/context-menu-operations.service';
import { LmsRendererService } from '../../core/services/lms-renderer.service';
import { LmsTerminalStatusSubmenuService } from '../../core/services/lms-terminal-status-submenu.service';
import { PopupService } from '../../core/services/popup.service';
import { StaticDataStoreService } from '../../core/services/static-datastore.service';
import { UserService } from '../../core/services/user.service';
import { BreTransferAreaDetails } from './../../core/model/bre-transfer-area-details.model';
import { LmsException } from './../../core/model/lms-exception.model';
import { LocomotiveErrors } from './../../core/model/locomotive-error.model';
import { TerminalRoad } from './../../core/model/terminal-road-model';
import { TrainData } from './../../core/model/train-data.model';
import { AppUtilityService } from './../../core/services/app-utility.service';
import { ConfigService } from './../../core/services/config.service';
import { EditModeService } from './../../core/services/edit-mode.service';
import { LmsLoaderService } from './../../core/services/lms-loader.service';
import { LmsMenuService } from './../../core/services/lms-menu.service';
import { LmsModuleService } from './../../core/services/lms-module.service';
import { LmsTabsDragDropService } from './../../core/services/lms-tabs-drag-drop.service';
import { RouteChangePopupService } from './../../core/services/route-change-popup.service';
import { UtilService } from './../../core/services/util.service';
import { AddToPendingList, TerminalPending } from './../shared/model/terminal-pending.model';
import { AddToPendingService } from './../shared/services/add-to-pending.service';
import { TerminalConfigService } from './../shared/services/terminal-config.service';
import { TerminalStatusService } from './../shared/services/terminal-status.service';
import { LmsTerminalBoundListComponent } from './lms-terminal-bound-list/lms-terminal-bound-list.component';
import { LmsTerminalStatusHeaderComponent } from './lms-terminal-status-header/lms-terminal-status-header.component';



/**
 * @export
 * @class LmsTerminalComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-terminal-status',
  templateUrl: './terminal-status.component.html',
  styleUrls: ['./terminal-status.component.scss']
})
@PermitAll()
export class LmsTerminalStatusComponent extends LmsBaseAppComponent implements OnInit, OnDestroy {
  @ViewChild(LmsTerminalStatusHeaderComponent) lmsTerminalStatusHeaderComponent: LmsTerminalStatusHeaderComponent;
  tabTerminalSubscription: any;
  transferResponse: BaseResponse;
  messages;
  private dropEndSubscription: any;
  private dragOverSubscription: any;
  selectedIntendedUsageCode: any;
  disableCancelComplete: boolean;
  intendedUsageCode = [];
  rendererSubscription: any;
  terminalStatusMenuSubscription: any;
  contextMenuOperationsSubscription: any;
  contextMenuServiceSubscription: any;
  private trainLocoDataSubscription: any;
  private addToPendingSubscription;
  searchPlanTextTerminal: string;
  trainLocoData: Object = {
    trains: {
      list: []
    },
    locos: {
      list: []
    }
  };
  intendedTrainLocoData: Object = {
    trains: {
      list: []
    },
    locos: {
      list: []
    }
  };
  resequenceTrainType = 'outBoundTrains';
  resequenceTrainData: TrainData;
  trainIdentifier: string;
  pendingListData: TerminalPending;
  dragLocosData: Array<Object> = [];
  mileposts: Array<string> = [];
  mnemonics: Array<string> = [];
  responseHeader: Response;
  filteredResults: Array<string> = [];
  thpPlanLoco = 'S';
  popupStatus: Object = {
    terminal: false,
    train: false,
    plan: false,
    completeTrain: false,
    cancelTrain: false,
    confirm: false,
    resequence: false,
    mix: false
  };
  popupType = '';
  popupOpen: Boolean = false;
  errorDialog: Boolean = false;
  popUpErrorMessage = '';
  mixErrorTitle = 'Error: Mixed Operations';
  mixErrorMessage = 'Train and Locomotive operations can not be mixed.';
  resetPopUpErrorMessage = '';
  locoErrorResponse: LocomotiveErrors;
  planOption: Array<Object> = [
    { label: 'Train', value: 'Train' },
    { label: 'Terminal', value: 'Terminal' },
    { label: 'Foreign Railroad', value: 'Foreign Railroad' }
  ];

  selectedPlan = 'Train';
  roadValues: Array<TerminalRoad>;
  selectedTerminalRoad: string;
  selectedRoadValues: SelectItem[];
  planTrainId: string;
  isAddTrainError: boolean;
  beforResequenceOrder: Array<LocoDetail>;
  searchPlanTextTerminalError: Boolean;
  selectedTerminalRoadError: Boolean;
  private addToPendingData: AddToPendingList;
  private commonopsPicklist;
  private startDrag: Boolean = false;
  ruleException = false;
  isRuleExceptionSubmitEnabled: boolean;
  lmsExceptionList: Array<LmsException> = [];
  windowCode = 'LWTW';
  lmsOutputExceptionList: Array<LmsException> = [];
  inOutBoundHeight: number;
  pendingActionHeight: number;
  fullPageModeHeight: number;
  onTermEachSlideHeight = 57;
  configData;
  tabLevel: number;
  showHeader: boolean;

  @ViewChild(LmsTerminalBoundListComponent) lmsTerminalBoundListComponent: LmsTerminalBoundListComponent;
  popUpServiceSubscription: any;
  isValidThpSelection = false;
  selectedLocomotiveArr: Array<LocoDetail> = [];

  constructor(lmsModuleService: LmsModuleService,
    lmsMenuService: LmsMenuService,
    configService: ConfigService,
    private terminalStatusService: TerminalStatusService,
    private terminalConfigService: TerminalConfigService,
    utilService: UtilService,
    private lmsTabsDragDropService: LmsTabsDragDropService,
    private addToPendingService: AddToPendingService,
    editModeService: EditModeService,
    routeChangePopupService: RouteChangePopupService,
    private staticDataStoreService: StaticDataStoreService,
    private lmsLoaderService: LmsLoaderService,
    private appUtilityService: AppUtilityService,
    popupService: PopupService,
    private lmsRenderer: LmsRendererService,
    private contextMenuOperationsService: ContextMenuOperationsService,
    private lmsTerminalStatusSubmenuService: LmsTerminalStatusSubmenuService,
    public user: UserService) {

    // base app component setting done
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routeChangePopupService, popupService);
    this.messages = this.terminalConfigService.terminalConfigData.messages;
    this.service = terminalStatusService;
    this.configData = this.configService.getConfigData();
    this.tabLevel = this.configData.tabIndex.dialogBox;


    this.type = this.configData.menu.type.terminal;
    this.roadValues = [];
    this.selectedRoadValues = [];
    this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');

    if(staticDataStoreService.getValue('SHOW_HEADER') == false)
    {
        this.showHeader = false;
        this.lmsTerminalStatusSubmenuService.count = 6;
        // this.user.accessLevel = 'R';

        for (let i = 0; i < this.lmsTerminalStatusSubmenuService.terminalStatusList.length; i++) {
              const item = this.lmsTerminalStatusSubmenuService.terminalStatusList[i];
              item.active = true;
          }
    }
    else
        this.showHeader = true;

    this.dragOverSubscription = this.lmsTabsDragDropService.over$.pipe(
      debounceTime(50))
      .subscribe(data => {
        if (data.dragElement.type === 'OUTBOUND' || data.dragElement.type === 'INBOUND') {
          if (!this.startDrag) {
            this.resequenceTrainType = 'outBoundTrains';
            if (data.dropElement.type === 'INBOUND') {
              this.resequenceTrainType = 'inBoundTrains';
            }
            for (let i = 0; i < this.loadData.terminalStatusIO[this.resequenceTrainType].length; i++) {
              this.loadData.terminalStatusIO[this.resequenceTrainType][i].resequenceStart = false;
            }
            if (this.loadData.terminalStatusIO[this.resequenceTrainType][data.dragElement.train.index]) {
              this.loadData.terminalStatusIO[this.resequenceTrainType][data.dragElement.train.index].resequenceStart = true;
            }
            this.startDrag = true;
          }
        }
      });

    // subscribes darg and drop data and set which popup will open on that case
    this.dropEndSubscription = this.lmsTabsDragDropService.end$.subscribe(data => {
      let isTrainIncidentPopup = false;
      const seletcedTrainLocos = this.getSelectedTrainLocos();
      this.hideContextMenu('hide'); // this call to hide any opened context menu
      this.resetPopupStatus();
      this.startDrag = false;
      this.trainLocoData['locos']['list'] = seletcedTrainLocos.locos;
      this.trainLocoData['trains']['list'] = seletcedTrainLocos.trains;

      this.mixErrorTitle = 'Error: Mixed Operations';
      this.mixErrorMessage = 'Train and Locomotive operations can not be mixed.';

      if (data.requenceCanHappen) {
        let locoMatchTrainCount = 0;
        for (let i = 0; i < seletcedTrainLocos.locos.length; i++) {
          if (this.trainLocoData['locos']['list'][i].trainLocoMixId.split('-')[0] === data.dropElement.train.identifier) {
            locoMatchTrainCount++;

          }
        }
        if (locoMatchTrainCount === seletcedTrainLocos.locos.length) {
          data.dragElement.train = data.dropElement.train;

          this.resequenceTrainType = 'outBoundTrains';
          if (data.dropElement.type === 'INBOUND') {
            this.resequenceTrainType = 'inBoundTrains';
          }
          this.loadData.terminalStatusIO[this.resequenceTrainType][data.dropElement.train.index].resequenceStart = true;
        }
      }

      if (data.dropElement.type !== 'train' && this.isAnyPendingTrainAction()) {
        this.popupStatus['mix'] = true;

      } else if (data.dropElement.type === 'train' && this.isAnyPendingLocoAction()) {
        this.popupStatus['mix'] = true;

      } else if (data.dragElement && data.dragElement.loco && data.dragElement.loco.data && this.checkLocoExistInSelectedLocos(data.dragElement.loco.data)) {
        // checking that drag loco id are alreday existing n selected locos
        this.setMixPopupforDuplicatedLocos(data.dragElement.loco.data.locomotiveIdentifier);
        return false;
      } else if (this.isAlreadySameLocoIdExistInPendingAction(this.trainLocoData['locos']['list'], data.dragElement.loco.data)) {
        // checking that drag loco id are alreday existing in Pending list
        this.setMixPopupforPendingListDuplicatedLocos(data.dragElement.loco.data.locomotiveIdentifier);
      } else {

        if (data.dropElement.type === 'yardAndLocalList' && data.dragElement.type !== 'yardAndLocalList') {
          const dragLocosData = seletcedTrainLocos.locos;
          if (!_.isUndefined(data.dragElement.loco.data)) {
            this.setLocoEnableState(data.dragElement.loco.data, true);
          }
          if (dragLocosData.length) {
            dragLocosData[0] = {...dragLocosData[0], 'locoAllocStation': this.selectedTab.tabSearchParameter.searchText};
          }

          const operation = {
            operation: 'AllocateLocomotives',
            data: dragLocosData,
            windowCode: 'LWTW'
          };
          this.popupService.setPopupOperation(operation);
        } else {



        this.dragLocosData = [];
        this.trainIdentifier = data.dropElement.train && data.dropElement.train.data ? data.dropElement.train.data.trainIdentifier : '';
        if (data.dropElement.train && data.dropElement.train.data) {
          this.trainLocoData['trains']['list'] = [];
          this.trainLocoData['trains']['list'].push(data.dropElement.train.data);
        }
        this.resequenceTrainData = this.trainIdentifier ? data.dropElement.train.data : null;
        this.intendedTrainLocoData = JSON.parse(JSON.stringify(this.trainLocoData));
        this.popupStatus[this.lmsTabsDragDropService.popupType[`${data.dragElement.type}-${data.dropElement.type}`]] = true;
        if (this.lmsTabsDragDropService.popupType[`${data.dragElement.type}-${data.dropElement.type}`] === 'train' || this.lmsTabsDragDropService.popupType[`${data.dragElement.type}-${data.dropElement.type}`] === 'plan') {
          isTrainIncidentPopup = true;
        }
        const submitButtonId = [this.lmsTabsDragDropService.popupType[`${data.dragElement.type}-${data.dropElement.type}`]] + 'SubmitPopup';

        this.popUpErrorMessage = this.lmsTabsDragDropService.headerMessage[this.lmsTabsDragDropService.popupType[`${data.dragElement.type}-${data.dropElement.type}`]];
        this.resetPopUpErrorMessage = this.popUpErrorMessage;
        this.setPageMode({ mode: 'Dialog', id: submitButtonId });

        this.dragLocosData = seletcedTrainLocos.locos;
        if (data.dragElement.loco.identifier && data.trainLocos.locos.list.indexOf(data.dragElement.loco.data) === -1) {
          if (_.indexOf(this.dragLocosData, data.dragElement.loco.data) === -1) {
            this.dragLocosData.push(data.dragElement.loco.data);
          }
          if (_.indexOf(this.trainLocoData['locos']['list'], data.dragElement.loco.data) === -1) {
            this.trainLocoData['locos']['list'].push(data.dragElement.loco.data);
          }
        }

        // set data in addtopending Section
        for (let i = 0; i < this.dragLocosData.length; i++) {
          this.dragLocosData[i]['locomotiveIdentifier'] = this.appUtilityService.removeSpaceLocomotiveId(this.dragLocosData[i]['locomotiveIdentifier']);

        }

        this.addToPendingData = {
          trains: this.trainLocoData ? this.trainLocoData['trains']['list'] : data.trainLocos.trains.list,
          locos: this.dragLocosData
        };

        // if drop on same train then resequne popup will show rest hide
        // but if any loco selected from any list then it will not  resequence
        if (data.dropElement.train &&
          !_.isEmpty(data.dropElement.train.data) &&
          data.dragElement.train &&
          !_.isEmpty(data.dragElement.train.data)) {
          if (data.dropElement.train.data.trainIdentifier === data.dragElement.train.data.trainIdentifier) {
            // resequence only work on OutbOUND and INBOUND SECTION
            if (data.dropElement.type === 'OUTBOUND' || data.dropElement.type === 'INBOUND') {
              this.resequenceTrainType = 'outBoundTrains';
              if (data.dropElement.type === 'INBOUND') {
                this.resequenceTrainType = 'inBoundTrains';
              }
              // now here we are checking that all selected loco
              // are exist in this same train if not then its not a resequence operation
              const locoslength = this.trainLocoData['locos']['list'].length;
              const selectedlocomotives = this.trainLocoData['locos']['list'];
              let isResequence = true;
              if (locoslength) {
                for (let k = 0; k < locoslength; k++) {
                  if (_.findIndex(data.dropElement.train.data.locoDetails, this.trainLocoData['locos']['list'][k]) === -1) {
                    isResequence = false;
                    break;
                  }
                }
              }

              if (isResequence) {
                this.resetPopupStatus();
                // here we need to set resequence order but first we are cheking that drag start from this train
                if (data.dropElement.train.index && this.loadData.terminalStatusIO[this.resequenceTrainType][data.dropElement.train.index].resequenceStart) {
                  const dragStartTrain = this.loadData.terminalStatusIO[this.resequenceTrainType][data.dropElement.train.index];
                  const dragLocoIndex = data.dragElement.loco.index !== 'last' ?
                    parseInt(data.dragElement.loco.index, 10) :
                    dragStartTrain.locoDetails.length - 1;

                  const dropLocoIndex = data.dropElement.loco.index !== 'last' ?
                    parseInt(data.dropElement.loco.index, 10) :
                    dragStartTrain.locoDetails.length - 1;
                  if (dragLocoIndex !== dropLocoIndex) {
                    let plannedLocsCounter = 0;

                    // if all the loco which are drag on same train but
                    // are planned then we are opening plan loco popup ###1

                    for (let i = 0; i < selectedlocomotives.length; i++) {
                      if (this.appUtilityService.isPlannedLoco(selectedlocomotives[i])) {
                        plannedLocsCounter++;
                      }
                    }

                    if (plannedLocsCounter === selectedlocomotives.length) {
                      isTrainIncidentPopup = true;
                      this.intendedTrainLocoData = JSON.parse(JSON.stringify(this.trainLocoData));
                      this.popupStatus['train'] = true;
                      this.planTrainId = this.trainIdentifier;
                      this.popUpErrorMessage = this.lmsTabsDragDropService.headerMessage['plan'];
                    } else {
                      // else we are opening resequence popup ####2

                      // dragStartTrain.locoDetails[dragLocoIndex].resequenceOrder = dropLocoIndex;
                      let locoDetails: Array<LocoDetail> = this.loadData.terminalStatusIO[this.resequenceTrainType][data.dropElement.train.index].locoDetails;
                      const tempOrder = locoDetails;
                      this.beforResequenceOrder = tempOrder;
                      locoDetails = this.utilService.shift(dragLocoIndex, dropLocoIndex, locoDetails, selectedlocomotives);
                      this.loadData.terminalStatusIO[this.resequenceTrainType][data.dropElement.train.index].locoDetails = locoDetails;
                      for (let k = 0; k < locoDetails.length; k++) {
                        locoDetails[k].resequenceOrder = k;
                      }
                      isTrainIncidentPopup = false;
                      this.popupStatus['resequence'] = true;
                      this.popUpErrorMessage = 'Resequence Locomotive';
                    }
                  }
                  // }
                  //  this.loadData.terminalStatusIO.outBoundTrains[data.dropElement.train.index].resequenceStart = false;
                }
                //   this.popupStatus['resequence'] = true;
              }
            } else {
              this.trainLocoData['locos']['list'].splice(this.trainLocoData['locos']['list'].length - 1, 1);
              //   this.resetPopupStatus();
            }
          }
        } else {
          // if not resequencce then make clickabe loco
        }
        //  this.loadData.terminalStatusIO.outBoundTrains[data.dropElement.train.index].resequenceStart = false;
        // in every case we are making clickable
        if (!_.isUndefined(data.dragElement.loco.data)) {
          this.setLocoEnableState(data.dragElement.loco.data, true);
        }
      }
      if (isTrainIncidentPopup && (this.trainIdentifier || this.popupStatus['plan'])) {
        this.resetPopupStatus();
        this.getLocoIncident(this.trainIdentifier ? 'train' : 'plan');
      } else {
        this.checkValidServiceCenterShopForTerminal();
      }
    }});


    this.contextMenuOperationsSubscription = this.contextMenuOperationsService.contextMenuOperationData$.subscribe(data => {
      this.mixErrorTitle = 'Error: Mixed Operations';
      this.mixErrorMessage = 'Train and Locomotive operations can not be mixed.';

      // do related to add to pending
      this.addToPendingData = {
        trains: data.popupOperation.trainData ? data.popupOperation.trainData : [],
        locos: data.popupOperation.mainLocodata
      };
      if (this.isAnyPendingTrainAction()) {
        this.popupStatus['mix'] = true;
      } else if (this.checkLocosExistInSelectedLocos(this.addToPendingData.locos)) {
        // checking that drag loco id are alreday existing n selected locos
        this.setMixPopupforDuplicatedLocos(this.addToPendingData.locos[0].locomotiveIdentifier);
        return false;
      } else if (this.isAlreadySameLocoIdsExistInPendingAction([], this.addToPendingData.locos)) {
        // checking that drag loco id are alreday existing in Pending list
        this.setMixPopupforPendingListDuplicatedLocos(this.addToPendingData.locos[0].locomotiveIdentifier);
      } else {
        this.setLocoTrainPendindStatus(true, data.popupOperation.operation);
        if (data.popupOperation.operation === 'UpdateThp') {
          this.addToPendingService.addInPendingList(this.addToPendingData, data.popupOperation.operation, data.request.thpTerminal, '', '', data.request, !data.addToPendingStatus);

        } else {
          this.addToPendingService.addInPendingList(this.addToPendingData, data.popupOperation.operation, data.popupOperation.data.thpTerminal, '', '', data.popupOperation, !data.addToPendingStatus);
        }
      }
    });

    this.contextMenuServiceSubscription = this.contextMenuOperationsService.contextMenuServiceData$.subscribe(data => {
      this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
      this.terminalStatusService.load(this.selectedTab, data.status, data.message);
    });

    this.trainLocoDataSubscription = this.lmsTabsDragDropService.interactiveLocoTrains$.subscribe(data => {
      document.getElementsByTagName('body')[0].click();
      const selectedLocosTrains = this.getSelectedTrainLocos();
      const selectedLocos = selectedLocosTrains.locos;
      const selectedTrains = selectedLocosTrains.trains;

      // we are checking that already with same loco id
      // any other loc is selected if yes then we show
      // that dupliacted loco are selected and reselect
      // the clicked loco

      if (this.checkLocoExistInSelectedLocos(data)) {
        this.setMixPopupforDuplicatedLocos(data.locomotiveIdentifier);
        return true;

      } else if (this.isAlreadySameLocoIdExistInPendingAction([], data)) {
        // we are checking that already with same loco id
        // any other loc is in pending list if yes then we show
        // that dupliacted loco are already in pending list and reselect
        // the clicked loco

        this.setMixPopupforPendingListDuplicatedLocos(data.locomotiveIdentifier);
        this.setLocoEnableState(data, false);
        return true;
      }


      this.trainLocoData['locos']['list'] = selectedLocos;

      if (this.trainLocoData['trains']['list'].length) {
        if (selectedTrains.length) {
          this.trainLocoData['trains']['list'] = this.trainLocoData['trains']['list'].concat(selectedTrains);
        }
      } else {
        this.trainLocoData['trains']['list'] = selectedTrains;
      }
      this.addToPendingData = {
        trains: this.trainLocoData['trains'] ? this.trainLocoData['trains']['list'] : '',
        locos: this.trainLocoData['locos']['list']
      };
    });

    this.addToPendingSubscription = this.addToPendingService.terminalPL$.subscribe(data => {
      this.pendingListData = <TerminalPending>data;
    });

    this.rendererSubscription = this.lmsRenderer.resizeObervable.pipe(debounceTime(50)).subscribe(() => {
      this.initializePageHeight();
    });

    this.terminalStatusMenuSubscription = this.lmsTerminalStatusSubmenuService.terminalStatusMenu.subscribe(() => {
      this.initializePageHeight();
    });

    this.popUpServiceSubscription = this.popupService.popupOprObservable.subscribe((data) => {
      this.checkSuccessOperation(data);
    });

  }
  private isAlreadySameLocoIdsExistInPendingAction(selectedLocos: Array<LocoDetail>, dragLocos: Array<LocoDetail>) {
    let counter = 0;

    for (let i = 0; i < dragLocos.length; i++) {
      if (this.isAlreadySameLocoIdExistInPendingAction(selectedLocos, dragLocos[i])) {
        counter++;
      }
    }
    return counter ? true : false;
  }

  private isAlreadySameLocoIdExistInPendingAction(selectedLocos: Array<LocoDetail>, dragLoco: LocoDetail) {
    if (_.isUndefined(this.pendingListData) || _.isUndefined(this.pendingListData.pendingList) || _.isUndefined(dragLoco)) {
      return false;
    }
    if (_.indexOf(selectedLocos, dragLoco) === -1) {
      selectedLocos.push(dragLoco);
    }

    for (let i = 0; i < this.pendingListData.pendingList.length; i++) {
      for (let j = 0; j < this.pendingListData.pendingList[i].locos.length; j++) {
        for (let k = 0; k < selectedLocos.length; k++) {
          if (this.appUtilityService.removeSpaceLocomotiveId(selectedLocos[k].locomotiveIdentifier) === this.appUtilityService.removeSpaceLocomotiveId(this.pendingListData.pendingList[i].locos[j].locomotiveIdentifier)
            // && selectedLocos[k].trainLocoMixId === this.pendingListData.pendingList[i].locos[j].trainLocoMixId
          ) {
            return true;
          }
        }
      }
    }
    return false;

  }

  /**
   * @private
   * @memberof LmsTerminalStatusComponent
   */

  private setMixPopupforDuplicatedLocos(locoId) {
    this.popupStatus['mix'] = true;
    this.mixErrorTitle = this.terminalConfigService.terminalConfigData.messages.duplicateLocosPopupTitle;
    let mixErrorMessage = this.terminalConfigService.terminalConfigData.messages.duplicateLocosPopupMessage;
    if (locoId !== '' && locoId !== undefined) {
      mixErrorMessage = mixErrorMessage.replace('Duplicate Locomotive', 'Duplicate Locomotive (' + this.appUtilityService.UIformatLocomotiveId(locoId) + ') ');
    }
    this.mixErrorMessage = mixErrorMessage;
  }

  /**
   * @private
   * @memberof LmsTerminalStatusComponent
   */
  private setMixPopupforPendingListDuplicatedLocos(locoId) {
    this.popupStatus['mix'] = true;
    this.mixErrorTitle = this.terminalConfigService.terminalConfigData.messages.duplicateLocosinPendingListPopupTitle;
    let mixErrorMessage = this.terminalConfigService.terminalConfigData.messages.duplicateLocosinPendingListPopupMessage;
    if (locoId !== '' && locoId !== undefined) {
      mixErrorMessage = mixErrorMessage.replace('Duplicate Locomotive', 'Duplicate Locomotive (' + this.appUtilityService.UIformatLocomotiveId(locoId) + ') ');
    }
    this.mixErrorMessage = mixErrorMessage;
  }

  /**
   * we are checking that already with same loco id
  * any other loc is selected if yes then we show
  * that dupliacted loco are selected
   * @param loco LocoDetail Object
   * return true if loco found in selected locs
   * else return false
   */

  private checkLocoExistInSelectedLocos(loco: LocoDetail): Boolean {
    const selectedLocos = this.getSelectedTrainLocos().locos;
    if (loco.locomotiveIdentifier) {
      for (let i = 0; i < selectedLocos.length; i++) {
        if (selectedLocos[i].locomotiveIdentifier === loco.locomotiveIdentifier && selectedLocos[i].trainLocoMixId !== loco.trainLocoMixId) {
          this.setLocoEnableState(loco, false);
          return true;
        }
      }
    }
    return false;
  }


  /**
   * we are checking that already with same loco id
  * any other loc is selected if yes then we show
  * that dupliacted loco are selected
   * @param loco LocoDetail Object
   * return true if loco found in selected locs
   * else return false
   */

  private checkLocosExistInSelectedLocos(locos: Array<LocoDetail>): Boolean {
    const selectedLocos = this.getSelectedTrainLocos().locos;
    let matchCounter = 0;
    for (let i = 0; i < selectedLocos.length; i++) {
      for (let j = 0; j < locos.length; j++) {
        if (selectedLocos[i].locomotiveIdentifier === locos[j].locomotiveIdentifier && selectedLocos[i].trainLocoMixId !== locos[j].trainLocoMixId) {
          this.setLocoEnableState(locos[j], false);
          matchCounter++;
        }
      }
    }
    return matchCounter ? true : false;
  }

  /**
   * @param {LocoDetail} locoDetail
   * @param {boolean} [clickedStatus]
   * @memberof LmsTerminalStatusComponent
   */

  setLocoEnableState(locoDetail: LocoDetail, clickedStatus?: boolean) {
    const inBoundTrain = this.loadData.terminalStatusIO.inBoundTrains;
    const inBoundLength = inBoundTrain.length;
    const outBoundTrain = this.loadData.terminalStatusIO.outBoundTrains;
    const outBoundLength = outBoundTrain.length;
    const terminalList = this.loadData.terminalStatusLocos;
    const totalTerminalListLocos = [terminalList.onTerminalList,
    terminalList.atServiceCentreList,
    terminalList.onPitList,
    terminalList.inShopList,
    terminalList.inReadyTrackList,
    terminalList.storedAtTerminalList,
    terminalList.yardAndLocalList
    ];


    for (let i = 0; i < inBoundLength; i++) {
      // checking for locos
      for (const loco of inBoundTrain[i].locoDetails) {
        if (locoDetail.trainLocoMixId === loco.trainLocoMixId) {
          loco.clicked = clickedStatus;
        }
      }

    }

    for (let i = 0; i < outBoundLength; i++) {
      // checking for locos
      for (const loco of outBoundTrain[i].locoDetails) {
        if (locoDetail.trainLocoMixId === loco.trainLocoMixId) {
          loco.clicked = clickedStatus;
        }
      }
    }

    for (let i = 0; i < totalTerminalListLocos.length; i++) {
      if (!_.isEmpty(totalTerminalListLocos[i])) {
        for (let r = 0; r < totalTerminalListLocos[i].length; r++) {
          if (totalTerminalListLocos[i][r].trainLocoMixId === locoDetail.trainLocoMixId) {
            totalTerminalListLocos[i][r].clicked = clickedStatus;
          }
        }
      }
    }
    this.addToPendingService.updatePendingListStatus(true);
    this.lmsTabsDragDropService.updateInteractiveLocoTrains();
  }




  private isAnyPendingTrainAction() {
    if (this.pendingListData) {
      return _.filter(this.pendingListData.pendingList, (item) => {
        return item.action === 'complete' || item.action === 'cancel';
      }).length;
    } return 0;
  }

  private isAnyPendingLocoAction() {
    if (this.pendingListData) {
      return _.filter(this.pendingListData.pendingList, (item) => {
        return !(item.action === 'complete' || item.action === 'cancel');
      }).length;
    }
    return 0;
  }

  formatLocoId(locoId) {
    return this.appUtilityService.formatLocomotiveId(locoId);
  }

  private getSelectedTrainLocos() {
    const selectedLocos: Array<LocoDetail> = [];
    const selectedTrains: Array<TrainData> = [];
    const inBoundTrains = this.loadData.terminalStatusIO.inBoundTrains;
    const outBoundTrains = this.loadData.terminalStatusIO.outBoundTrains;
    const terminalList = this.loadData.terminalStatusLocos;
    const totalTerminalListLocos = [terminalList.onTerminalList,
    terminalList.atServiceCentreList,
    terminalList.onPitList,
    terminalList.inShopList,
    terminalList.inReadyTrackList,
    terminalList.storedAtTerminalList,
    terminalList.yardAndLocalList
    ];
    const inBoundTrainsLength = inBoundTrains.length;
    const outBoundTrainsLength = outBoundTrains.length;
    // for inBoundTrains
    for (let i = 0; i < inBoundTrainsLength; i++) {
      if (inBoundTrains[i].clicked && !inBoundTrains[i].inPendingList) {
        selectedTrains.push(inBoundTrains[i]);
      }
      const locos = inBoundTrains[i].locoDetails;
      const locosLength = locos.length;
      for (let k = 0; k < locosLength; k++) {
        if (locos[k].clicked && !locos[k].inPendingList) {
          selectedLocos.push(locos[k]);
        }
      }
    }

    // for outboundTrains
    for (let i = 0; i < outBoundTrainsLength; i++) {
      if (outBoundTrains[i].clicked && !outBoundTrains[i].inPendingList) {
        selectedTrains.push(outBoundTrains[i]);
      }
      const locos = outBoundTrains[i].locoDetails;
      const locosLength = locos.length;
      for (let k = 0; k < locosLength; k++) {
        if (locos[k].clicked && !locos[k].inPendingList) {
          selectedLocos.push(locos[k]);
        }
      }
    }

    for (let i = 0; i < totalTerminalListLocos.length; i++) {
      if (!_.isEmpty(totalTerminalListLocos[i])) {
        for (let k = 0; k < totalTerminalListLocos[i].length; k++) {
          if (totalTerminalListLocos[i][k].clicked && !totalTerminalListLocos[i][k].inPendingList) {
            totalTerminalListLocos[i][k]['isTerminalStatusLoco'] = true;
            selectedLocos.push(totalTerminalListLocos[i][k]);
          }
        }
      }

    }
    return {
      'trains': _.sortBy(selectedTrains, 'order'),
      'locos': _.sortBy(selectedLocos, 'order')
    };
  }

  autoCompleteForTerminal(event) {
    this.mnemonics = [];
    this.mileposts = [];
    if (!this.commonopsPicklist) {
      this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    }
    if (this.commonopsPicklist) {
      const data = this.commonopsPicklist.mapOfMnemonis ? this.commonopsPicklist.mapOfMnemonis : null;
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          this.mnemonics.push(data[key]);
          this.mileposts.push(key);
        }
      }
    }
    this.filteredResults = this.mnemonics.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    });

    Array.prototype.push.apply(this.filteredResults, (this.mileposts.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    })));
    this.filteredResults = this.filteredResults.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) === index;
    });
    this.filteredResults.sort();
  }


  selectValueFromAutoComplete(value: string, type: string) {
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoadError = false;
    this.selectedTerminalRoad = '';

    let emitValue = value;
    if (!this.commonopsPicklist) {
      this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    }
    if (!this.roadValues || this.roadValues && this.roadValues.length === 0) {
      if (this.commonopsPicklist && this.commonopsPicklist.masterData && this.commonopsPicklist.masterData.interchangeList &&
        this.commonopsPicklist.masterData.interchangeList.length > 0) {
        for (let i = 0; i < this.commonopsPicklist.masterData.interchangeList.length; i++) {
          const terminalRoad: TerminalRoad = this.commonopsPicklist.masterData.interchangeList[i];
          this.roadValues.push(terminalRoad);
        }
      }
    }
    if (this.commonopsPicklist) {
      const data = this.commonopsPicklist.mapOfMnemonis ? this.commonopsPicklist.mapOfMnemonis : null;
      if (data) {
        if (data[value]) {
          emitValue = data[value];
        }
      }
    }
    if (this.roadValues) {
      this.selectedRoadValues = [];
      const filteredRoadValues: Array<TerminalRoad> = this.roadValues.filter((terminalRoad) => {
        return terminalRoad.terminal === emitValue;
      });
      if (filteredRoadValues && filteredRoadValues.length > 0) {
        this.selectedRoadValues.push({
          label: 'Select',
          value: 'Select'
        });
      }
      for (const filteredRoadValue of filteredRoadValues) {
        this.selectedRoadValues.push({
          label: filteredRoadValue.road,
          value: filteredRoadValue.road
        });
        if (this.selectedRoadValues && this.selectedRoadValues.length > 0) {
          this.selectedTerminalRoad = this.selectedRoadValues[0].value;
        }
      }
      if (this.selectedPlan === 'Foreign Railroad') {
        if (!filteredRoadValues || (filteredRoadValues && filteredRoadValues.length <= 0)) {
          this.errorDialog = true;
          this.popUpErrorMessage = this.configData.messages.planInvalidInterchangeRoad;
        } else {
          this.resetPopupErrors();
        }
      }
    }
    if ('terminalPlanSuggestSearch' === type) {
      this.searchPlanTextTerminal = emitValue;
    }
    if (this.popupStatus['plan'] && !this.appUtilityService.isValidThpSelection(this.searchPlanTextTerminal)) {
      this.thpPlanLoco = 'M';
      this.isValidThpSelection = true;
    } else {
      this.thpPlanLoco = 'S';
      this.isValidThpSelection = false;
    }
  }
  /**
   * hide allpopup which we call on every popup cancel button
   */
  private resetPopupStatus() {
    this.popupStatus = {
      terminal: false,
      train: false,
      plan: false,
      completeTrain: false,
      cancelTrain: false,
      confirm: false,
      resequence: false,
      mix: false
    };

    this.ruleException = false;
    this.resetPopupErrors();
    this.resetPopupSearchValues();

  }


  private resetPopupErrors() {
    this.popUpErrorMessage = this.resetPopUpErrorMessage;
    this.errorDialog = false;
    this.isAddTrainError = false;
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoadError = false;
  }

  private resetPopupSearchValues() {
    this.selectedTerminalRoad = '';
    this.searchPlanTextTerminal = '';
    this.selectedRoadValues = [];
    this.planTrainId = '';
    this.thpPlanLoco = 'S';
    this.selectedTerminalRoad = '';
    this.selectedPlan = 'Train';
  }
  /**
   * This is used to load Terminal Data
   * @memberOf LmsTerminalComponent
   */
  ngOnInit() {
    if (!this.commonopsPicklist) {
      this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    }
    if (this.commonopsPicklist && this.commonopsPicklist.masterData && this.commonopsPicklist.masterData.interchangeList &&
      this.commonopsPicklist.masterData.interchangeList.length > 0) {
      for (let i = 0; i < this.commonopsPicklist.masterData.interchangeList.length; i++) {
        const terminalRoad: TerminalRoad = this.commonopsPicklist.masterData.interchangeList[i];
        this.roadValues.push(terminalRoad);
      }
    }
    super.init(this.search);
    this.initializePageHeight();
  }

  // hide popup
  hideDialog() {
    this.resetPopupStatus();
    this.disableCancelComplete = false;
  }

  // add to pending action done
  addToPending(data, action: string, terminalVal?: string, trainId?: string) {
    document.getElementsByTagName('body')[0].click();
    if (event) {
      event.stopPropagation();
    }
    this.resetPopupErrors();
    let terminal = terminalVal || this.searchPlanTextTerminal;
    let road = '';
    let error = false;
    if (_.isUndefined(this.addToPendingData.trains)) {
      this.addToPendingData.trains = [];
    }
    if (action === 'Foreign Railroad') {
      if (!this.appUtilityService.isMnemonicExist(this.searchPlanTextTerminal)) {
        this.searchPlanTextTerminalError = true;
      } else {
        this.searchPlanTextTerminalError = false;
      }
      if (!this.selectedTerminalRoad) {
        this.selectedTerminalRoadError = true;
      } else {
        this.selectedTerminalRoadError = false;
      }
      terminal = this.searchPlanTextTerminal;
      road = this.selectedTerminalRoad;
    } else if (action === 'Train') {
      this.planTrainId = trainId ? trainId : this.planTrainId;
      if (this.appUtilityService.isValidTrainId(this.planTrainId)) {
        this.planTrainId = this.planTrainId.toUpperCase();
        this.isAddTrainError = false;

        if (!_.isEmpty(_.filter(this.loadData.terminalStatusIO.outBoundTrains, { trainIdentifier: this.planTrainId })[0])) {
          this.addToPendingData.trains[0] = _.filter(this.loadData.terminalStatusIO.outBoundTrains, { trainIdentifier: this.planTrainId })[0];
        }
        if (!_.isEmpty(_.filter(this.loadData.terminalStatusIO.inBoundTrains, { trainIdentifier: this.planTrainId })[0])) {
          this.addToPendingData.trains[0] = _.filter(this.loadData.terminalStatusIO.inBoundTrains, { trainIdentifier: this.planTrainId })[0];
        }

        if (_.isEmpty(this.addToPendingData.trains[0])) {
          this.addToPendingData.trains[0] = { 'trainIdentifier': this.planTrainId };
        }
      } else {
        this.isAddTrainError = true;
        error = true;
      }

    } else if (action === 'Terminal') {
      if (this.appUtilityService.isMnemonicExist(terminal)) {
        this.searchPlanTextTerminalError = false;
      } else if (this.appUtilityService.isMnemonicExist(this.searchPlanTextTerminal)) {
        terminal = this.searchPlanTextTerminal;
        this.searchPlanTextTerminalError = false;
      } else {
        this.searchPlanTextTerminalError = true;
      }
    } else if (action === 'resequence') {

      this.addToPendingData.trains[0] = _.filter(this.loadData.terminalStatusIO[this.resequenceTrainType], { trainIdentifier: this.addToPendingData.trains[0].trainIdentifier })[0];


    }
    if (!(this.isAddTrainError || this.searchPlanTextTerminalError || this.selectedTerminalRoadError)) {
      if (action && action === 'Terminal' && this.thpPlanLoco && this.thpPlanLoco.trim().toUpperCase() === 'S') {
        if (this.appUtilityService.isValidThpSelection(this.searchPlanTextTerminal)) {
          this.setLocoTrainPendindStatus(true, action);
          const planType = this.thpPlanLoco;
          this.addToPendingService.addInPendingList(this.addToPendingData, action, terminal, road, planType);
          this.lmsTabsDragDropService.updateInteractiveLocoTrains();
          this.hideDialog();
        } else {
          this.lmsLoaderService.hideLoader();
          this.errorDialog = true;
          this.popUpErrorMessage = this.configData.messages.invalidThpSelection;
        }
      } else {
        this.setLocoTrainPendindStatus(true, action);
        const planType = this.thpPlanLoco;
        if (this.addToPendingData && this.addToPendingData.locos) {
          this.intendedTrainLocoData['locos']['list'] = JSON.parse(JSON.stringify(this.addToPendingData.locos));
        }
        if (action && action === 'Train' && this.intendedTrainLocoData) {
          let isNoteError = false;
          const selectedLocmotives = this.intendedTrainLocoData['locos']['list'];
          for (let p = 0; p < selectedLocmotives.length; p++) {
            if (selectedLocmotives[p] && selectedLocmotives[p].intendedUsgaeNoteRequired && (!selectedLocmotives[p].intendedUsageNote || (selectedLocmotives[p].intendedUsageNote && selectedLocmotives[p].intendedUsageNote.length === 0))) {
              selectedLocmotives[p].isIntendedUsageNotError = true;
              isNoteError = true;
            } else {
              selectedLocmotives[p].isIntendedUsageNotError = false;
            }
          }
          if (!isNoteError) {
            this.addToPendingData.locos = this.intendedTrainLocoData['locos']['list'];
            this.addToPendingService.addInPendingList(this.addToPendingData, action, terminal, road, planType);
            this.lmsTabsDragDropService.updateInteractiveLocoTrains();
            this.hideDialog();
          }
        } else {
          this.addToPendingService.addInPendingList(this.addToPendingData, action, terminal, road, planType);
          this.lmsTabsDragDropService.updateInteractiveLocoTrains();
          this.hideDialog();
        }
      }
    }
  }


  public cancelCompleteTrainOperation(data, eventType: string) {
    document.getElementsByTagName('body')[0].click();
    if (event) {
      event.stopPropagation();
    }
    if (this.lmsTerminalStatusHeaderComponent.pendingActions.length === 0) {
      this.hideDialog();
      this.lmsTerminalStatusHeaderComponent.submitPendingAction();
      this.lmsLoaderService.showLoader();
      let opr: any;
      const cancelTrain = {
        station: this.selectedTab.tabSearchParameter.searchText,
        trainRow: [

        ]
      };

      for (let k = 0; k < data.trains.list.length; k++) {
        cancelTrain.trainRow.push({
          trainID: data.trains.list[k].trainIdentifier,
          trainType: data.trains.list[k].trainType
        });
      }
      if (eventType && eventType === 'completeTrain') {
        opr = 'CMPL';
      } else if (eventType && eventType === 'cancelTrain') {
        opr = 'CNCL';
      }
      let responseHeader = null;
      this.terminalStatusService.cancelCompleteTrain(cancelTrain, opr).subscribe(
        (responsedata) => {
          responseHeader = responsedata;
          if (this.isNumeric(responseHeader.header.priorityCode)) {
            const pCode = parseInt(responseHeader.header.priorityCode, 10);
            if (pCode >= 1 && pCode <= 4) {
              this.disableCancelComplete = false;
              this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
              this.terminalStatusService.load(this.selectedTab, true, responseHeader.header.messageText);
            } else {
              this.disableCancelComplete = true;
              this.errorDialog = true;
              this.popupStatus[eventType] = true;
              this.popUpErrorMessage = responseHeader.header.messageText;
              this.lmsLoaderService.hideLoader();
            }
          }
        }, error => {
          this.errorDialog = true;
          this.disableCancelComplete = false;
          this.popupStatus[eventType] = true;
          this.popUpErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
          this.lmsLoaderService.hideLoader();
        }
      );
    } else {
      if ('completeTrain' === eventType) {
        this.addToPending(this.trainLocoData, 'complete');
      } else if ('cancelTrain' === eventType) {
        this.addToPending(this.trainLocoData, 'cancel');
      }
      this.lmsTerminalStatusHeaderComponent.submitPendingAction();
    }

  }

  private setLocoTrainPendindStatus(status: Boolean, action?: string, pendingData?: AddToPendingList) {
    const localPendingData = pendingData ? pendingData : this.addToPendingData;
    const inBoundTrain = this.loadData.terminalStatusIO.inBoundTrains;
    const inBoundLength = inBoundTrain.length;
    const outBoundTrain = this.loadData.terminalStatusIO.outBoundTrains;
    const outBoundLength = outBoundTrain.length;
    const terminalList = this.loadData.terminalStatusLocos;
    const totalTerminalListLocos = [terminalList.onTerminalList,
    terminalList.atServiceCentreList,
    terminalList.onPitList,
    terminalList.inShopList,
    terminalList.inReadyTrackList,
    terminalList.storedAtTerminalList,
    terminalList.yardAndLocalList
    ];

    for (let i = 0; i < inBoundLength; i++) {
      // checking for locos
      for (const loco of inBoundTrain[i].locoDetails) {
        if (localPendingData.locos.indexOf(loco) > -1) {
          loco.inPendingList = status;
          loco.checked = status;

        }
      }

      if (!(action && (action === 'Train' || action === 'Foreign Railroad' || action === 'Terminal'))) {

        // checking for train
        if (localPendingData.trains.indexOf(inBoundTrain[i]) > -1) {
          inBoundTrain[i].inPendingList = status;
          inBoundTrain[i].checked = status;
        }
      }

    }

    for (let i = 0; i < outBoundLength; i++) {
      // checking for locos
      for (const loco of outBoundTrain[i].locoDetails) {
        if (localPendingData.locos.indexOf(loco) > -1) {
          loco.inPendingList = status;
          loco.checked = status;

        }
      }
      if (!(action && (action === 'Train' || action === 'Foreign Railroad' || action === 'Terminal'))) {
        // checking for train
        if (localPendingData.trains.indexOf(outBoundTrain[i]) > -1) {
          outBoundTrain[i].inPendingList = status;
          outBoundTrain[i].checked = status;
        }
      }
    }

    for (let i = 0; i < totalTerminalListLocos.length; i++) {
      if (!_.isEmpty(totalTerminalListLocos[i])) {
        for (let r = 0; r < totalTerminalListLocos[i].length; r++) {
          if (localPendingData.locos.indexOf(totalTerminalListLocos[i][r]) > -1) {
            totalTerminalListLocos[i][r].inPendingList = status;
            totalTerminalListLocos[i][r].checked = status;
          }
        }
      }
    }
    this.addToPendingService.updatePendingListStatus(true);

  }
  /**
   * this mehtod is used to hide context panel
   * of train or locomotive in case any scroll event occurs
   * on page
   * @param {any} event
   * @memberOf LmsTerminalComponent
   */
  public hideLocoTrainContextPanel(event) {
    const isScroll = event;
    if (isScroll) {
      this.hideContextMenuChild();
    }
  }

  /**
   * this method is used to show the context panel for locomotive
   * when user right click on any locomotive icon
   * @param {any} event
   * @memberOf LmsTerminalComponent
   */
  public showLocomotiveContextForStatus(event) {
    document.getElementsByTagName('body')[0].click();
    this.hideContextMenuChild();
    const loco = event.get('locoData');
    const header = event.get('header');
    const headerName = event.get('headerName');
    this.locoStatusOpr = {
      header: header,
      headerName: headerName
    };
    setTimeout(() => {
      this.selectedLoco = loco;
      this.selectedLocoId = 'loco' + this.selectedLoco.locomotiveIdentifier;
      this.selectedLoco.renderContextMenu = true;
    }, 5);
  }

  planLocomotiveSubmit(selectedPlan?: string) {
    document.getElementsByTagName('body')[0].click();
    if (event) {
      event.stopPropagation();
    }
    this.trainLocoData = JSON.parse(JSON.stringify(this.intendedTrainLocoData));
    if (this.lmsTerminalStatusHeaderComponent.pendingActions.length === 0) {
      this.resetPopupErrors();
      if (selectedPlan) {
        this.popupType = selectedPlan.toLowerCase();
        this.planTrainId = this.trainIdentifier;
        this.selectedPlan = selectedPlan;
        this.searchPlanTextTerminal = this.selectedTab.tabSearchParameter.searchText;
      } else {
        this.popupType = 'plan';
      }
      if (this.selectedPlan === 'Foreign Railroad') {
        if (this.appUtilityService.isMnemonicExist(this.searchPlanTextTerminal) && (this.selectedTerminalRoad && 'Select' !== this.selectedTerminalRoad)) {
          this.lmsLoaderService.showLoader();
          this.submitTransferToForeignRailRoad(this.popupType);
          this.lmsTerminalStatusHeaderComponent.submitPendingAction();
        } else {
          if (!this.appUtilityService.isMnemonicExist(this.searchPlanTextTerminal)) {
            this.searchPlanTextTerminalError = true;
          } else {
            this.searchPlanTextTerminalError = false;
          }
          if (!this.selectedTerminalRoad || 'Select' === this.selectedTerminalRoad) {
            this.selectedTerminalRoadError = true;
          } else {
            this.selectedTerminalRoadError = false;
          }
        }
      } else if (this.selectedPlan === 'Train') {
        if (this.appUtilityService.isValidTrainId(this.planTrainId)) {
          let isNoteError = false;
          const selectedLocmotives = this.intendedTrainLocoData['locos']['list'];
          for (let p = 0; p < selectedLocmotives.length; p++) {
            if (selectedLocmotives[p] && selectedLocmotives[p].intendedUsgaeNoteRequired && (!selectedLocmotives[p].intendedUsageNote || (selectedLocmotives[p].intendedUsageNote && selectedLocmotives[p].intendedUsageNote.length === 0))) {
              selectedLocmotives[p].isIntendedUsageNotError = true;
              isNoteError = true;
            } else {
              selectedLocmotives[p].isIntendedUsageNotError = false;
            }
          }
          if (!isNoteError) {
            this.trainLocoData = JSON.parse(JSON.stringify(this.intendedTrainLocoData));
            this.lmsLoaderService.showLoader();
            this.planTrainId = this.planTrainId.toUpperCase();
            this.serviceCallToBre(this.planTrainId, selectedLocmotives, this.popupType);
          }
          this.isAddTrainError = false;
        } else {
          this.isAddTrainError = true;
        }
      } else if (this.selectedPlan === 'Terminal') {
        if (this.appUtilityService.isMnemonicExist(this.searchPlanTextTerminal)) {
          if (this.thpPlanLoco && this.thpPlanLoco.trim().toUpperCase() === 'S') {
            if (this.appUtilityService.isValidThpSelection(this.searchPlanTextTerminal)) {
              this.lmsLoaderService.showLoader();
              this.searchPlanTextTerminal = this.searchPlanTextTerminal.toUpperCase();
              this.submitTransferToTerminal(this.popupType);
              this.lmsTerminalStatusHeaderComponent.submitPendingAction();
            } else {
              this.lmsLoaderService.hideLoader();
              this.errorDialog = true;
              this.popUpErrorMessage = this.configData.messages.invalidThpSelection;
            }
          } else {
            this.lmsLoaderService.showLoader();
            this.searchPlanTextTerminal = this.searchPlanTextTerminal.toUpperCase();
            this.submitTransferToTerminal(this.popupType);
            this.lmsTerminalStatusHeaderComponent.submitPendingAction();
          }
        } else {
          this.searchPlanTextTerminalError = true;
        }
      }
    } else {
      const thpPlan = this.thpPlanLoco;
      if ('Terminal' === selectedPlan) {
        if (thpPlan && thpPlan.trim().toUpperCase() === 'S') {
          if (this.appUtilityService.isValidThpSelection(this.selectedTab.tabSearchParameter.searchText)) {
            this.addToPending(this.trainLocoData, 'Terminal', this.selectedTab.tabSearchParameter.searchText);
          } else {
            this.lmsLoaderService.hideLoader();
            this.errorDialog = true;
            this.popUpErrorMessage = this.configData.messages.invalidThpSelection;
          }
        } else {
          this.addToPending(this.trainLocoData, 'Terminal', this.selectedTab.tabSearchParameter.searchText);
        }
      } else if ('Train' === selectedPlan) {
        this.addToPending(this.trainLocoData, 'Train', '', this.trainIdentifier);
      } else {
        this.addToPending(this.trainLocoData, this.selectedPlan);
      }
      if (selectedPlan && 'Terminal' === selectedPlan && thpPlan && thpPlan.trim().toUpperCase() === 'S') {
        if (this.appUtilityService.isValidThpSelection(this.selectedTab.tabSearchParameter.searchText)) {
          this.lmsTerminalStatusHeaderComponent.submitPendingAction();
        }
      } else {
        this.lmsTerminalStatusHeaderComponent.submitPendingAction();
      }
    }

  }

  submitTransferToTerminal(popupType: string) {
    const locoTransfer: Array<LocoTransfer> = [];
    const planType = this.thpPlanLoco;
    this.createLocoTransferListForTerminal(locoTransfer, this.searchPlanTextTerminal, planType);
    this.serviceCallLocoTransfer(locoTransfer, 'XSTA', popupType);
  }

  submitTransferToForeignRailRoad(popupType: string) {
    const locoTransfer: Array<LocoTransfer> = [];
    this.createLocoTransferListForForeignRoad(locoTransfer, this.searchPlanTextTerminal, ' ', this.selectedTerminalRoad);
    this.serviceCallLocoTransfer(locoTransfer, 'XROD', popupType);
  }


  createLocoTransferListForForeignRoad(locoTransfer: Array<LocoTransfer>, terminal: string, terminalType: string, road: string) {
    const selectedLocmotives = this.trainLocoData['locos']['list'];
    for (let i = 0; i < selectedLocmotives.length; i++) {
      const selectedLocmotive = this.trainLocoData['locos']['list'][i];
      const a = {
        currentTerminalIdentifier: this.selectedTab.tabSearchParameter.searchText, // To be verified
        toRoadIdentifier: road,
        terminalHandlingType: terminalType,
        atStation: terminal,
        locoTransferList: {
          locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
          qualifier: selectedLocmotive.qualifier,
          assignedOrPlanned: selectedLocmotive.assignedPlannedFlag
        }
      };
      locoTransfer.push(a);

    }
  }

  createLocoTransferListForTerminal(locoTransfer: Array<LocoTransfer>, terminal: string, terminalType: string) {
    const selectedLocmotives = this.trainLocoData['locos']['list'];
    for (let i = 0; i < selectedLocmotives.length; i++) {
      const selectedLocmotive = this.trainLocoData['locos']['list'][i];
      const a = {
        currentTerminalIdentifier: this.selectedTab.tabSearchParameter.searchText, // To be To be verified
        terminalIdentifier: terminal,
        terminalHandlingType: terminalType,
        locoTransferList: {
          locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
          qualifier: selectedLocmotive.qualifier,
          assignedOrPlanned: selectedLocmotive.assignedPlannedFlag
        }
      };
      locoTransfer.push(a);
    }
  }

  createLocoTransferListForTrain(locoTransfer: Array<LocoTransfer>, trainsId: string) {
    const selectedLocmotives = this.trainLocoData['locos']['list'];
    for (let i = 0; i < selectedLocmotives.length; i++) {
      const selectedLocmotive = this.trainLocoData['locos']['list'][i];
      let notes = selectedLocmotive.intendedUsageNote;
      if (notes) {
        notes = notes.toUpperCase();
      }
      const a = {
        currentTerminalIdentifier: this.selectedTab.tabSearchParameter.searchText, // To be To be verified
        trainIdentifier: trainsId,
        terminalHandlingType: this.thpPlanLoco,
        locoTransferList: {
          locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
          qualifier: selectedLocmotive.qualifier,
          assignedOrPlanned: selectedLocmotive.assignedPlannedFlag,
          intendedUsageCode: selectedLocmotive.intendedUsageCode,
          intendedUsageReason: selectedLocmotive.intendedUsageReason,
          intendedUsageNotes: notes
        }
      };
      locoTransfer.push(a);
    }
  }



  serviceCallLocoTransfer(locoTransfer: Array<LocoTransfer>, operation: string, popupType: string) {
    this.terminalStatusService.transferLocomotive(locoTransfer, operation).subscribe(
      (data) => {
        this.transferResponse = <BaseResponse>data;
        if (this.isNumeric(this.transferResponse.header.priorityCode)) {
          const pCode = parseInt(this.transferResponse.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.popupStatus[popupType] = false;
            this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
            this.hideDialog();
            this.terminalStatusService.load(this.selectedTab, true, this.transferResponse.header.messageText);
          } else {
            this.lmsLoaderService.hideLoader();
            this.errorDialog = true;
            this.popUpErrorMessage = this.transferResponse.header.messageText;
          }
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popUpErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
      });
  }

  /**
    * this method is used to hide the context panel of locomotive
    * which comes in open state when user right click on locomotive
    * svg icon
    * @memberOf LmsTrainComponent
    **/
  @HostListener('document:click') hideContextMenuChild() {
    super.hideContextMenu('host');
  }


  /**
   * This is used to search TerminalStatus
   * @memberOf LmsTerminalComponent
   */
  search() {
    if (this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status === 'refresh') {
      this.selectedTab.openState = { headerName: '', status: null, activeStatus: false, collpase: null, singleClick: true };
      this.lmsModuleService.updateSelectedTab(this.selectedTab);
    }
    this.initializePageHeight();
    super.search();
  }

  /**
  * Remove error when error message is closed
  * @param {any} event
  * @memberOf LmsTerminalComponent
  */
  clearErrorMessage(event) {
    this.selectedTab.subTypeDetail.status.message = '';

    // this.updateTab(this.selectedTab);
    const editModeStatus = {
      status: false,
      message: ''
    };

    this.editModeService.setEditMode(editModeStatus);
    setTimeout(() => {
      this.lmsModuleService.updateSelectedTab(this.selectedTab);
    }, 5);
  }

  ngOnDestroy() {
    super.destroy();
    this.dropEndSubscription.unsubscribe();
    this.dragOverSubscription.unsubscribe();
    this.trainLocoDataSubscription.unsubscribe();
    this.addToPendingSubscription.unsubscribe();
    this.rendererSubscription.unsubscribe();
    this.terminalStatusMenuSubscription.unsubscribe();
    this.contextMenuOperationsSubscription.unsubscribe();
    this.contextMenuServiceSubscription.unsubscribe();
    this.popUpServiceSubscription.unsubscribe();
  }

  serviceCallToBre(trainId: string, selectedLocmotives: Array<LocoDetail>, popUpType: string) {
    const locoId: Array<String> = [];
    for (let i = 0; i < selectedLocmotives.length; i++) {
      const selectedLocmotive = this.trainLocoData['locos']['list'][i];
      locoId.push(this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier));
    }
    this.terminalStatusService.breTransferRequest(locoId, trainId).subscribe(
      (data) => {
        const breTrasferParam: BreTransferAreaDetails = <BreTransferAreaDetails>data;
        if (breTrasferParam && breTrasferParam.priorityCode) {
          const pCode = parseInt(breTrasferParam.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            if (this.isLmsExceptionListExist(breTrasferParam)) {
              this.lmsLoaderService.hideLoader();
              this.popupStatus[popUpType] = false;
              this.ruleException = true;
              this.popupService.setPageMode('Dialog');
              this.popupService.setSubmitBtnId('ruleExceptionLocoData');

              const newLmsExceptionList: Array<LmsException> = [];
              for (let i = 0; i < breTrasferParam.lmsExceptionList.length; i++) {
                const lmsException: LmsException = breTrasferParam.lmsExceptionList[i];
                const locoObj: LocoDetail = this.getLocoObjById(lmsException.locoId, selectedLocmotives);
                if (locoObj) {
                  let intendedUsageNotes = locoObj.intendedUsageNote;
                  if (intendedUsageNotes) {
                    intendedUsageNotes = intendedUsageNotes.toUpperCase();
                  }
                  lmsException.intendedUsageDesc = this.appUtilityService.getIntendedUsageDesc(locoObj.intendedUsageCode);
                  lmsException.intendedUsageReason = this.appUtilityService.getIntendedUsageReasonDesc(locoObj.intendedUsageReason);
                  lmsException.intendedUsageNote = intendedUsageNotes;
                }
                lmsException.isSelectedLoco = false;
                newLmsExceptionList.push(lmsException);
              }
              this.lmsExceptionList = newLmsExceptionList;

              const checkedExceptionList: Array<LmsException> = this.lmsExceptionList.filter((lmsException) => {
                return lmsException.isSelectedLoco;
              });
              if (checkedExceptionList && checkedExceptionList.length > 0) {
                this.isRuleExceptionSubmitEnabled = true;
              }
            } else {
              const locoTransfer: Array<LocoTransfer> = [];
              this.createLocoTransferListForTrain(locoTransfer, trainId);
              this.serviceCallLocoTransfer(locoTransfer, 'XTRN', popUpType);
            }
          } else {
            this.errorDialog = true;
            this.popUpErrorMessage = breTrasferParam.messageText;
          }
        }

      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popUpErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
      }
    );
  }

  getLocoObjById(locoId: string, locoArr: Array<LocoDetail>): LocoDetail {
    for (let x = 0; x < locoArr.length; x++) {
      const oldLocoId = this.appUtilityService.UIformatLocomotiveId(locoId);
      const newLocoId = this.appUtilityService.UIformatLocomotiveId(locoArr[x].locomotiveIdentifier);
      if (oldLocoId && newLocoId && oldLocoId.trim().toUpperCase() === newLocoId.trim().toUpperCase()) {
        return locoArr[x];
      }
    }
  }

  ruleExceptionSubmit(type: string) {
    document.getElementsByTagName('body')[0].click();
    if (event) {
      event.stopPropagation();
    }
    const locoTransfer: Array<LocoTransfer> = [];
    const selectedLocmotives = this.trainLocoData['locos']['list'];
    for (let j = 0; j < selectedLocmotives.length; j++) {
      const selectedLocmotive = this.trainLocoData['locos']['list'][j];
      for (let i = 0; i < this.lmsExceptionList.length; i++) {
        const lmsException: LmsException = this.lmsExceptionList[i];
        if (lmsException.isSelectedLoco) {
          let isException = false;
          if (lmsException.tripPlamCompExcptnInd && lmsException.tripPlamCompExcptnInd === 'E') {
            if (!lmsException.tripPlanOverrideCode) {
              this.lmsExceptionList[i].isLmsExceptionInAddReason = true;
              isException = true;
            } else {
              this.lmsExceptionList[i].isLmsExceptionInAddReason = false;
            }
          }
          if (lmsException.unschdQShopExcptnInd && lmsException.unschdQShopExcptnInd === 'Y') {
            if (!lmsException.unscheduledQShop) {
              this.lmsExceptionList[i].isLmsExceptionInAddQShop = true;
              isException = true;
            } else {
              this.lmsExceptionList[i].isLmsExceptionInAddQShop = false;
            }
          }
          if (!isException) {
            if (this.appUtilityService.formatLocomotiveId(lmsException.locoId).replace('    ', '') ===
              this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier).replace('    ', '')) {
              const a = {
                currentTerminalIdentifier: this.selectedTab.tabSearchParameter.searchText, // To be To be verified
                terminalHandlingType: this.thpPlanLoco,
                trainIdentifier: this.planTrainId,
                locoTransferList: {
                  locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
                  qualifier: selectedLocmotive.qualifier,
                  assignedOrPlanned: selectedLocmotive.assignedPlannedFlag,
                  tripPlanCompIndicator: lmsException.tripPlamCompExcptnInd,
                  tripPlanTrainIdentifier: lmsException.tripPlanTrnId,
                  tripPlanOverrideCode: lmsException.tripPlanOverrideCode,
                  tripPlanOverrideReason: lmsException.tripPlanOverrideReason,
                  unscheduledQShop: lmsException.unscheduledQShop,
                  unscheduledQShopDate: lmsException.unscheduledQShopDate,
                  intendedUsageCode: selectedLocmotive.intendedUsageCode,
                  intendedUsageReason: selectedLocmotive.intendedUsageReason,
                  intendedUsageNotes: selectedLocmotive.intendedUsageNote
                }
              };
              locoTransfer.push(a);
            }
          }
        }
      }
    }
    if (locoTransfer && locoTransfer.length > 0) {
      this.ruleException = false;
      this.popupStatus[type] = true;
      this.serviceCallLocoTransfer(locoTransfer, 'XTRN', type);
    }
  }

  submitPendingActionThroughTerminalStatus() {
    this.lmsTerminalStatusHeaderComponent.submitPendingAction();
  }

  checkCheckedLoco() {
    const checkedExceptionList: Array<LmsException> = this.lmsExceptionList.filter((lmsException) => {
      return lmsException.isSelectedLoco;
    });
    if (checkedExceptionList && checkedExceptionList.length > 0) {
      this.isRuleExceptionSubmitEnabled = true;
    } else {
      this.isRuleExceptionSubmitEnabled = false;
    }
  }

  lmsExceptionOutput(event) {
    this.lmsExceptionList = event.lmsExceptionList;
  }

  changePlanOptions() {
    this.searchPlanTextTerminal = '';
    this.selectedTerminalRoad = '';
    this.selectedRoadValues = [];
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoadError = false;
    this.thpPlanLoco = 'S';
    this.isValidThpSelection = false;
    this.isAddTrainError = false;
    // this.planTrainId = '';
    this.popUpErrorMessage = this.resetPopUpErrorMessage;
    this.errorDialog = false;

    setTimeout(() => {
      if (this.selectedPlan && this.selectedPlan !== 'Train') {
        this.setFocusToGivenElement('terminalStatusPlanCommInput');
      } else if (this.selectedPlan && this.selectedPlan === 'Train') {
        this.setFocusToGivenElement('terminalStatusPlanTrnInput');
      }
    }, 5);
    this.fillTerminalValue();
  }

  isLmsExceptionListExist(breTrasferParam: BreTransferAreaDetails): boolean {
    if (breTrasferParam && breTrasferParam.lmsExceptionList && breTrasferParam.lmsExceptionList.length > 0) {
      for (let i = 0; i < breTrasferParam.lmsExceptionList.length; i++) {
        const lmsExcpetion = breTrasferParam.lmsExceptionList[i];
        if (lmsExcpetion && 'E' === lmsExcpetion.tripPlamCompExcptnInd) {
          return true;
        }
        if (lmsExcpetion && 'Y' === lmsExcpetion.unschdQShopExcptnInd) {
          return true;
        }
        if (lmsExcpetion && lmsExcpetion.exceptionMessage && lmsExcpetion.exceptionMessage.length > 0) {
          return true;
        }
      }
    }
    return false;
  }

  initializePageHeight() {
    const windowHeight = this.lmsRenderer.getWindowHeight();
    const viewStausHeight = this.getOnTerminalNodesHeight();
    let heightToAdjust = 0;
    // if window width is less then 1280 then to avoid the vertical scroll, we have to remove the height of horizontal scroll
    if (this.lmsRenderer.getWindowWidth() < 1280) {
      heightToAdjust = 22;
    }
    this.inOutBoundHeight = windowHeight - viewStausHeight - 156 - 7 - heightToAdjust;
    this.fullPageModeHeight = windowHeight - 160 - heightToAdjust;
    if (this.selectedTab && this.selectedTab.openState && this.selectedTab.openState.activeStatus) {
      this.pendingActionHeight = this.fullPageModeHeight;
    } else if (this.selectedTab && this.selectedTab.openState && !this.selectedTab.openState.singleClick && this.selectedTab.openState.collpase !== null) {
      this.inOutBoundHeight = this.fullPageModeHeight;
      this.pendingActionHeight = this.inOutBoundHeight;
    } else {
      this.pendingActionHeight = this.inOutBoundHeight;
    }

    if (this.lmsTerminalBoundListComponent) {
      this.lmsTerminalBoundListComponent.setScreenSize();
    }
  }

  private getOnTerminalNodesHeight(): number {
    let height = 0;
    if (this.lmsTerminalStatusSubmenuService && this.lmsTerminalStatusSubmenuService.terminalStatusList) {
      this.lmsTerminalStatusSubmenuService.terminalStatusList.forEach((item) => {
        if (item.active) {
          height += item.height;
        }
      });
    }
    return height;
  }

  dragover() {
    return false;
  }

  /**
   * @param {any} e
   * @param {any} dropId
   * @returns
   *
   * @memberOf LmsTabsComponent
   */
  drop() {
    return false;
  }

  planDialogPageMode(setPageData) {
    super.setPageMode(setPageData);
  }

  setPageMode(setPageData) {
    super.setPageMode(setPageData);
    if (!this.disableCancelComplete) {
      setTimeout(() => {
        this.appUtilityService.setFocusToFirstElement(`${setPageData.id}Dialog`);
      }, 20);
    } else {
      setTimeout(() => {
        let submitBtn;
        let submitId = '';
        if ('cancelTrainSubmitPopup' === setPageData.id) {
          submitBtn = document.getElementById('cancelTrainTerminalId');
          submitId = 'cancelTrainTerminalId';
        } else if ('completeTrainSubmitPopup' === setPageData.id) {
          submitBtn = document.getElementById('completeTrainTerminalId');
          submitId = 'completeTrainTerminalId';
        }
        if (submitBtn) {
          this.popupService.setPageMode('Dialog');
          this.popupService.setSubmitBtnId(submitId);
          submitBtn.focus();
        }
      }, 20);
    }
  }

  public setFocusToGivenElement(inputId: string, timeOut?: string) {
    if (inputId && inputId.length > 0) {
      if (!timeOut) {
        const input = document.getElementById(inputId);
        if (input) {
          setTimeout(() => {
            input.focus();
          }, 20);
        }
      }
      if (timeOut) {
        setTimeout(() => {
          const input = document.getElementById(inputId);
          if (input) {
            input.focus();
          }
        }, 20);
      }
    }
  }

  /**
   * Retrieve loco incident for loco .
   * @param {string} popupType
   * @memberof LmsTerminalStatusComponent
   */
  getLocoIncident(popupType: string) {
    if (this.trainLocoData['locos']['list']) {
      for (let i = 0; i < this.trainLocoData['locos']['list'].length; i++) {
        const locoData: LocoDetail = this.trainLocoData['locos']['list'][i];
        if (locoData && locoData.deadFlag && locoData.deadFlag.trim().toUpperCase() === 'Y') {
          this.trainLocoData['locos']['list'][i].locoIncident = 'OOS';

        } else if (locoData.trfIncidentS && locoData.trfIncidentS.trim().toUpperCase() === 'Y') {
          this.trainLocoData['locos']['list'][i].locoIncident = 'TRF';

        } else if (locoData.axles && locoData.axles.trim() === '4') {
          this.trainLocoData['locos']['list'][i].locoIncident = '4-ax';

        } else if (!locoData.axles || (locoData.axles && (locoData.axles.trim().length === 0 || locoData.axles.trim() === '6'))) {
          this.trainLocoData['locos']['list'][i].locoIncident = '6-ax';

        }
      }
    }
    this.intendedTrainLocoData = JSON.parse(JSON.stringify(this.trainLocoData));
    this.resetPopupStatus();
    this.popupStatus[popupType] = true;
    this.checkValidServiceCenterShopForTerminal();
  }

  private checkValidServiceCenterShopForTerminal() {
    if (this.popupStatus['terminal']) {
      if (!this.appUtilityService.isValidThpSelection(this.selectedTab.tabSearchParameter.searchText)) {
        this.thpPlanLoco = 'M';
      } else {
        this.thpPlanLoco = 'S';
      }
    }
    if (this.popupStatus['train']) {
      if (!this.appUtilityService.isValidThpSelection(this.selectedTab.tabSearchParameter.searchText)) {
        this.thpPlanLoco = 'M';
      } else {
        this.thpPlanLoco = 'S';
      }
    }
  }

  checkSuccessOperation(opr: any) {
    if (opr && opr.operation) {
      if ((opr.operation === 'updateIntendedSuccess' || opr.operation === 'allocateSuccess' || opr.operation === 'deallocateSuccess') && this.selectedTab && this.selectedTab.subTypeDetail) {
        // this.lmsTerminalStatusHeaderComponent.submitPendingAction();
        this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
        this.terminalStatusService.load(this.selectedTab, true, opr.message);
      } else if ((opr.operation === 'deAllocateError' || opr.operation === 'allocateLocoError') && this.selectedTab && this.selectedTab.subTypeDetail && this.selectedTab.subTypeDetail.status) {
        this.selectedTab.subTypeDetail.status.message = opr.message;
      }
    }
  }

  fillTerminalValue() {
    if (this.selectedTab && this.selectedTab && this.selectedTab.tabSearchParameter && this.selectedTab.tabSearchParameter.searchText) {
      this.searchPlanTextTerminal = this.selectedTab.tabSearchParameter.searchText.trim().toUpperCase();
      this.selectValueFromAutoComplete(this.searchPlanTextTerminal, 'terminalPlanSuggestSearch');
    }
  }
}

